import React from "react";
import { useFormContext } from "react-hook-form";

import Styles from "./StepThreeLegalForm.styles";
import { StepThreeLegalFormProps as Props } from "./StepThreeLegalForm.types";
import { StepThreeLegalFormValues } from "./StepThreeLegalForm.types";
import NumberInput from "components/global/NumberInput/NumberInput";
import useI18n from "hooks/useI18n";

const StepThreeLegalForm: React.FC<Props> = props => {
  const t = useI18n();
  const { control } = useFormContext<StepThreeLegalFormValues>();

  return (
    <Styles className="StepThreeLegalForm">
      <p className="StepThreeLegalForm__title">
        Detalla la situación patrimonial
      </p>

      <NumberInput
        name="totalIncome"
        control={control}
        label={t.legalStepThreeForm.totalIncome}
        placeholder="0.00"
        maxLength={10}
      />
      <NumberInput
        name="totalExpenditure"
        control={control}
        label={t.legalStepThreeForm.totalExpenditure}
        placeholder="0.00"
        maxLength={10}
      />
      <NumberInput
        name="totalAssets"
        control={control}
        label={t.legalStepThreeForm.totalAssets}
        placeholder="0.00"
        maxLength={10}
      />
      <NumberInput
        name="totalLiabilities"
        control={control}
        label={t.legalStepThreeForm.totalLiabilities}
        placeholder="0.00"
        maxLength={10}
      />
    </Styles>
  );
};

StepThreeLegalForm.defaultProps = {};

export default StepThreeLegalForm;
